type Variant =
  | "single-slides"
  | "stories-grid"
  | "story-slides"
  | "templates-grid";

const range = (n: number) => Array.from({ length: n }, (_, i) => i);

const SectionHeader = () => (
  <div className="tw-flex tw-items-center tw-gap-2 tw-px-6 tw-py-4">
    <span className="tw-block tw-h-4 tw-w-4 tw-shrink-0 tw-animate-pulse tw-rounded tw-bg-blue-100" />
    <span className="tw-block tw-h-5 tw-w-32 tw-animate-pulse tw-rounded tw-bg-blue-100" />
  </div>
);

const SlideCardRow = ({ count }: { count: number }) => (
  <div className="tw-flex tw-flex-wrap tw-gap-2 tw-px-6 tw-pb-4">
    {range(count).map((i) => (
      <div
        key={i}
        className="tw-flex tw-h-[170px] tw-w-[231px] tw-flex-col tw-gap-2 tw-rounded-xl tw-bg-white tw-p-2"
      >
        <span className="tw-block tw-h-[122px] tw-animate-pulse tw-rounded-lg tw-bg-blue-100" />
        <span className="tw-block tw-h-5 tw-w-2/3 tw-animate-pulse tw-rounded tw-bg-blue-100" />
      </div>
    ))}
  </div>
);

const SingleSlidesSkeleton = () => (
  <div>
    <SectionHeader />
    <SlideCardRow count={3} />
    <SectionHeader />
    <SlideCardRow count={6} />
  </div>
);

export const SearchSlidesSkeleton = ({ count = 6 }: { count?: number }) => (
  <SlideCardRow count={count} />
);

const StoriesGridSkeleton = ({ withHeader }: { withHeader: boolean }) => (
  <div>
    {withHeader && <SectionHeader />}
    <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-px-6 tw-pb-4 tw-pt-4">
      {range(4).map((i) => (
        <div key={i} className="tw-rounded-xl tw-p-2">
          <span className="tw-block tw-aspect-video tw-w-full tw-animate-pulse tw-rounded-lg tw-bg-blue-100" />
          <span className="tw-mt-3 tw-block tw-h-5 tw-w-1/2 tw-animate-pulse tw-rounded tw-bg-blue-100" />
        </div>
      ))}
    </div>
  </div>
);

const StorySlidesSkeleton = () => (
  <div className="tw-flex tw-flex-wrap tw-gap-4 tw-px-6 tw-pb-4 tw-pt-4">
    {range(4).map((i) => (
      <div key={i} className="tw-flex tw-w-[352px] tw-flex-col">
        <span className="tw-block tw-h-[198px] tw-animate-pulse tw-rounded-lg tw-bg-blue-100" />
        <span className="tw-mt-3 tw-block tw-h-5 tw-w-1/3 tw-animate-pulse tw-rounded tw-bg-blue-100" />
      </div>
    ))}
  </div>
);

const TemplatesGridSkeleton = () => (
  <div className="tw-space-y-4 tw-px-6 tw-py-4">
    <span className="tw-block tw-h-5 tw-w-36 tw-animate-pulse tw-rounded tw-bg-blue-100" />
    <div className="tw-grid tw-grid-cols-3 tw-gap-6">
      {range(6).map((i) => (
        <div key={i} className="tw-rounded-xl tw-bg-blue-50 tw-p-2">
          <span className="tw-block tw-h-[123px] tw-animate-pulse tw-rounded-lg tw-bg-blue-100" />
          <span className="tw-mt-2 tw-block tw-h-5 tw-w-2/3 tw-animate-pulse tw-rounded tw-bg-blue-100" />
        </div>
      ))}
    </div>
  </div>
);

export const SlidesLibraryContentSkeleton = ({
  variant = "templates-grid",
  withHeader = true,
}: {
  variant?: Variant;
  withHeader?: boolean;
} = {}) => {
  switch (variant) {
    case "single-slides":
      return <SingleSlidesSkeleton />;
    case "stories-grid":
      return <StoriesGridSkeleton withHeader={withHeader} />;
    case "story-slides":
      return <StorySlidesSkeleton />;
    case "templates-grid":
      return <TemplatesGridSkeleton />;
  }
};
